export default "__VITE_ASSET__sEw_iZ1w__"